<template>
	<div :style="{ height: bodyHeight + 'px' }" class="place-dir m-body">
		<van-image
			width="100%"
			height="1rem"
			:src="require('@/assets/images/m_head.png')"
		></van-image>
		
		<ul class="list qjc-clearfix">
			<li @click="to('http://sydadonghaiyihao.vip.lechengol.com/')" class="qjc-fl qjc-wid-100 qjc-relative">
				<van-image
					width="100%"
					height="4.46rem"
					:src="require('@/assets/images/m_bdt_img1.png')"
				></van-image>
				<h4 class="qjc-texta-c qjc-c-fff qjc-fts-30 qjc-absolute">度假村</h4>
			</li>
			<li class="qjc-fl qjc-wid-50 qjc-relative">
				<van-image
					width="100%"
					height="4.48rem"
					:src="require('@/assets/images/m_bdt_img2.png')"
				></van-image>
				<h4 class="qjc-texta-c qjc-c-fff qjc-fts-30 qjc-absolute">美食</h4>
			</li>
			<li class="qjc-fl qjc-wid-50 qjc-relative">
				<van-image
					width="100%"
					height="2.13rem"
					:src="require('@/assets/images/m_bdt_img3.png')"
				></van-image>
				<h4 class="qjc-texta-c qjc-c-fff qjc-fts-30 qjc-absolute">电影</h4>
			</li>
			<li class="qjc-fl qjc-wid-50 qjc-relative">
				<van-image
					width="100%"
					height="2.14rem"
					:src="require('@/assets/images/m_bdt_img4.png')"
				></van-image>
				<h4 class="qjc-texta-c qjc-c-fff qjc-fts-30 qjc-absolute">购物</h4>
			</li>
			<li @click="to('https://mp.weixin.qq.com/s/YyrXinQIEaS6r1Q0WB-Rwg')" class="qjc-fl qjc-wid-50 qjc-relative">
				<van-image
					width="100%"
					height="2.14rem"
					:src="require('@/assets/images/m_bdt_img5.png')"
				></van-image>
				<h4 class="qjc-texta-c qjc-c-fff qjc-fts-30 qjc-absolute">月子中心</h4>
			</li>
			<li class="qjc-fl qjc-wid-50 qjc-relative">
				<van-image
					width="100%"
					height="2.14rem"
					:src="require('@/assets/images/m_bdt_img6.png')"
				></van-image>
				<h4 class="qjc-texta-c qjc-c-fff qjc-fts-30 qjc-absolute">酒店</h4>
			</li>
			<li class="qjc-fl qjc-wid-50 qjc-relative">
				<van-image
					width="100%"
					height="2.14rem"
					:src="require('@/assets/images/m_bdt_img7.png')"
				></van-image>
				<h4 class="qjc-texta-c qjc-c-fff qjc-fts-30 qjc-absolute">休闲娱乐</h4>
			</li>
			<li class="qjc-fl qjc-wid-50 qjc-relative">
				<van-image
					width="100%"
					height="2.14rem"
					:src="require('@/assets/images/m_bdt_img8.png')"
				></van-image>
				<h4 class="qjc-texta-c qjc-c-fff qjc-fts-30 qjc-absolute">健身</h4>
			</li>
		</ul>
		
		<p class="foot qjc-fts-20">
			最终解释权归上海米因大数据科技有限公司所有
		</p>
		
		<m-footer></m-footer>
		
	</div>
</template>

<script>
	import Vue from 'vue'
	import { Image } from 'vant'
	Vue.use(Image);
	
	import MFooter from '@/components/m/Footer'
	
	export default{
		name: 'mPlaceDir',
		data() {
			return {
				bodyHeight: document.documentElement.clientHeight,
			}
		},
		components: {
			MFooter
		},
		methods: {
			to(url) {
				window.location.href = url;
			}
		}
	}
</script>

<style lang="scss" scoped>
	.place-dir{
		padding-top: 0.08rem;
		padding-bottom: 1.5rem;
		
		.list{
			margin: 0.22rem 0 0 0.24rem;
			
			li{
				padding-right: 0.24rem;
				margin-bottom: 0.18rem;
				
				h4{
					left: 0;
					right: 0.24rem;
					bottom: 0;
					font-weight: 500;
					height: 0.72rem;
					line-height: 0.72rem;
					background-color: rgba(0,0,0,.7);
				}
			}
		}
		
		.foot{
			color: #6E7EA0;
			margin-top: 0.32rem;
			text-align: center;
		}
	}
</style>
